/**
 * @__NO_SIDE_EFFECTS__
 */
export function defineProp(optsOrType) {
    return optsOrType || {};
}
//# sourceMappingURL=defineProp.js.map